'use client';

import { useMemo, useState, useCallback } from 'react';

import { MANUAL_CATALOG, MANUAL_PURPOSES } from 'src/constants/manual-catalog';

import { useGuideHeadingsLoad } from '../load/use-guide-headings-load';
import { searchGuide, buildGuideSearchIndex } from '../../utils/guide-search';

/**
 * 가이드 검색칸 — 찾는 말과 결과 줄. 머리 띠의 칸과 홈 첫 카드의 큰 칸이 각자 하나씩 쥔다.
 * 🔑 본문 제목 목록은 검색칸을 처음 건드릴 때 받는다(가이드를 열 때마다 묻지 않는다).
 * `run` 은 말을 넣고 바로 찾는다(홈의 「많이 찾는 키워드」).
 */
export function useGuideSearchModel() {
  const [query, setQuery] = useState('');
  const [touched, setTouched] = useState(false);
  const headings = useGuideHeadingsLoad(touched);
  const index = useMemo(() => buildGuideSearchIndex(MANUAL_CATALOG, headings, MANUAL_PURPOSES), [headings]);
  const results = useMemo(() => searchGuide(index, query), [index, query]);

  const touch = useCallback(() => setTouched(true), []);
  const run = useCallback((word: string) => {
    setTouched(true);
    setQuery(word);
  }, []);

  return { query, setQuery, results, touch, run };
}

export type GuideSearchModel = ReturnType<typeof useGuideSearchModel>;
